import type { InventoryItem } from '../types/inventory.types';
import { InventoryService } from './inventoryService';

/**
 * E-Ticaret işlemlerini yöneten servis (SQL API)
 */
export class EcommerceService {
  /**
   * Bir ürünün e-ticaret durumunu toggle eder (aç/kapat) - SQL API
   * @param companyId - Şirket ID'si
   * @param itemId - Ürün ID'si
   * @param item - Ürün bilgileri
   * @param currentStatus - Mevcut e-ticaret durumu
   * @returns Promise<{ success: boolean; newStatus: boolean; message: string }>
   */
  static async toggleEcommerceStatus(
    companyId: string,
    itemId: string,
    item: InventoryItem,
    currentStatus: boolean
  ): Promise<{ success: boolean; newStatus: boolean; message: string }> {
    try {
      const newStatus = !currentStatus; // Toggle: Açık ise kapat, kapalı ise aç
      
      console.log(`🛒 [ECOMMERCE TOGGLE] ${item.name} - Mevcut: ${currentStatus}, Yeni: ${newStatus}`);
      
      // ✅ SQL API ile tek ürün e-ticaret güncelleme
      await InventoryService.bulkToggleEcommerce(companyId, [itemId], newStatus);

      const actionText = newStatus ? 'e-ticarete açıldı' : 'e-ticaretten kapatıldı';
      console.log(`✅ ${item.name} ${actionText}`);
      
      return {
        success: true,
        newStatus: newStatus,
        message: `${item.name} ${actionText}`
      };
    } catch (error) {
      console.error('❌ E-ticaret durumu değiştirme hatası:', error);
      throw new Error('E-ticaret durumu değiştirilirken bir hata oluştu');
    }
  }

  /**
   * E-ticaretteki tüm aktif ürünleri getirir (SQL API)
   * IsEcommerce = true olan ürünlerin ID'lerini döndürür
   * @param companyId - Şirket ID'si
   */
  static async getActiveProducts(companyId: string): Promise<{ [key: string]: boolean }> {
    try {
      // SQL API ile e-ticaret aktif ürünleri getir
      const result = await InventoryService.getPagedItemsSQL(
        companyId,
        1,
        100000, // Tüm aktif e-ticaret ürünlerini al
        undefined,
        undefined,
        undefined,
        undefined,
        null,
        true // isEcommerce = true
      );

      const activeProducts: { [key: string]: boolean } = {};
      (result.items || []).forEach((item) => {
        activeProducts[item.id] = true;
      });

      return activeProducts;
    } catch (error) {
      console.error('❌ Aktif e-ticaret ürünleri alınamadı:', error);
      return {};
    }
  }

  /**
   * Toplu e-ticaret işlemi (açma/kapama) - SQL API
   * @param companyId - Şirket ID'si
   * @param items - İşlem yapılacak ürünler
   * @param action - 'open' veya 'close'
   */
  static async bulkToggleEcommerce(
    companyId: string,
    items: InventoryItem[],
    action: 'open' | 'close'
  ): Promise<{ success: number; failed: number }> {
    let successCount = 0;
    let failedCount = 0;

    for (const item of items) {
      try {
        const currentStatus = action === 'close'; // Kapatıyorsak şu an açık demektir
        await this.toggleEcommerceStatus(companyId, item.id, item, currentStatus);
        successCount++;
      } catch (error) {
        console.error(`❌ ${item.name} için e-ticaret işlemi başarısız:`, error);
        failedCount++;
      }
    }

    return { success: successCount, failed: failedCount };
  }
}
